import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_CASE_DOCUMENTATION_QUERY_KEY } from "../types/CommonTypes";
import { GET_GROUPED_CASE_DOCUMENTATION_RESPONSE } from "../types/ResponseTypes";

async function getCaseDocumentation(
  caseId?: string
): Promise<GET_GROUPED_CASE_DOCUMENTATION_RESPONSE> {
  console.log({ caseId });
  const { data } = await fetcher({
    url: `cases/${caseId}/form-entities`,
    params: {
      grouped: true,
    },
  });
  return data;
}

export default function useGetCaseDocumentationQuery(
  caseId?: string,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: [GET_CASE_DOCUMENTATION_QUERY_KEY, caseId],
    queryFn: () => getCaseDocumentation(caseId),
    enabled: !!caseId && enabled,
  });
}
